import { Component, OnDestroy, OnInit } from '@angular/core';
import { CreateWorkLogModal } from '../../modals/create-work-log/create-work-log.modal';
import { AuthenticationService, ModalService } from '@kaiser-software/chassis-core';

@Component({
    selector: 'app-add-work-log-plugin',
    templateUrl: 'add-work-log.plugin.html',
    styleUrls: ['add-work-log.plugin.scss']
})
export class AddWorkLogPlugin implements OnInit, OnDestroy {

    constructor(
        protected modalService: ModalService,
        public auth: AuthenticationService) {
    }

    public ngOnInit(): void {
    }

    public open() {
        const modal = this.modalService.open(CreateWorkLogModal);

        modal.result.then((result) => {
            console.log(result);
        }, (reject) => {
            console.log(reject);
        });
    }

    public ngOnDestroy(): void {
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/work-logs/plugins/add-work-log/add-work-log.plugin.ts